<template>
  <div id="indents">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>订单管理&nbsp;/&nbsp;订单列表</span>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="88"></el-tab-pane>
        <el-tab-pane name="0"><span slot="label"><el-badge class="mark" :value="totNum.total0" />待支付</span></el-tab-pane>
        <el-tab-pane name="1"><span slot="label"><el-badge class="mark" :value="totNum.total1" />待发货</span></el-tab-pane>
        <el-tab-pane name="2"><span slot="label"><el-badge class="mark" :value="totNum.total2" />已发货</span></el-tab-pane>
        <el-tab-pane name="3"><span slot="label"><el-badge class="mark" :value="totNum.total3" />已收货</span></el-tab-pane>
        <el-tab-pane name="4"><span slot="label"><el-badge class="mark" :value="totNum.total4" />已完成</span></el-tab-pane>
        <el-tab-pane name="5"><span slot="label"><el-badge class="mark" :value="totNum.total5" />已退款</span></el-tab-pane>
        <el-tab-pane name="6"><span slot="label"><el-badge class="mark" :value="totNum.total6" />已关闭</span></el-tab-pane>
        <el-tab-pane name="7"><span slot="label"><el-badge class="mark" :value="totNum.total7" />已无效</span></el-tab-pane>
        <el-tab-pane name="8"><span slot="label"><el-badge class="mark lastmark" :value="totNum.total8" />退款中</span></el-tab-pane>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS'></Provinces>
           <el-input class="elinputs" v-model="beginData.consignee" placeholder="收货人"></el-input>
           <el-input class="elinputs" v-model="beginData.goodsName" placeholder="商品名称"></el-input>
           <el-input class="elinputs" v-model="beginData.mobile" placeholder=" 收货人手机号"></el-input>
           <el-input class="elinputs" v-model="beginData.orderSn" placeholder=" 订单编号"></el-input>
           <el-input class="elinputs" v-model="beginData.userName" placeholder=" 用户昵称"></el-input>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click='reset'>重置</el-button>
          </div>
          <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
          </div>
          <el-table :data="tableData" @selection-change="handleSelectionChange" id="exportTab" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="orderSn" label="订单编号" width="180"></el-table-column>
            <el-table-column prop="goodsName" label="商品名称" min-width="260"></el-table-column>
            <el-table-column prop="userName" label="下单用户" width="160"></el-table-column>
            <el-table-column prop="consignee" label="收货人" width="160"></el-table-column>
            <el-table-column prop="mobile" label="联系电话" width="160"></el-table-column>
            <el-table-column label="订单状态" width="160">
                <template slot-scope="scope">
                    <!-- <p class="boldfont">{{stat(scope.row.orderStatus)}}</p> -->
                    <!-- <el-tag class="boldfont" type="success" v-if="scope.row.orderStatus==0">待支付</el-tag> -->
                    <p class="boldfont" style="color: #efa02a;" v-if="scope.row.orderStatus==0">待支付</p>
                    <p class="boldfont" style="color: #ff0000;" v-if="scope.row.orderStatus==1">待发货</p>
                    <p class="boldfont" style="color: #11A983;" v-if="scope.row.orderStatus==2">已发货</p>
                    <p class="boldfont" style="color: #efa02a;" v-if="scope.row.orderStatus==3">已收货</p>
                    <p class="boldfont" style="color: #11A983;" v-if="scope.row.orderStatus==4">已完成</p>
                    <p class="boldfont" style="color: #11A983;" v-if="scope.row.orderStatus==5">已退款</p>
                    <p class="boldfont" style="color: #000000;" v-if="scope.row.orderStatus==6">已关闭</p>
                    <p class="boldfont" style="color: #000000;" v-if="scope.row.orderStatus==7">已无效</p>
                    <p class="boldfont" style="color: #ff0000;" v-if="scope.row.orderStatus==8">退款中</p>
                </template>
            </el-table-column>
            <el-table-column prop="province" label="省份" width="120"></el-table-column>
            <el-table-column prop="city" label="城市" width="120"></el-table-column>
            <el-table-column prop="district" label="区县" width="120"></el-table-column>
            <el-table-column prop="address" label="详细地址" min-width="260"></el-table-column>
            <el-table-column prop="message" label="买家留言" width="200"></el-table-column>
            <el-table-column prop="goodsPrice" label="商品价" sortable width="120"></el-table-column>
            <el-table-column prop="couponPrice" label="优惠券" sortable width="120"></el-table-column>
            <el-table-column prop="freightPrice" label="运费" sortable width="120"></el-table-column>
            <el-table-column prop="actualPrice" label="实付款" sortable width="120"></el-table-column>
            <el-table-column prop="orderPrice" label="结算价" sortable width="120"></el-table-column>
            <!-- <el-table-column prop="readFalse" label="配送方式" width="120"></el-table-column> -->
            <el-table-column prop="addTime" label="下单时间" min-width="180"></el-table-column>
            <el-table-column prop="payTime" label="支付时间" min-width="180"></el-table-column>
            <el-table-column prop="shipTime" label="发货时间" min-width="180"></el-table-column>
            <el-table-column prop="confirmTime" label="收货时间" min-width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" min-width="280">
              <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(0,scope.row)"><i class="el-icon-edit"></i> 详情</el-button>
                <el-button size="mini" type="danger" v-if="scope.row.orderStatus==0" @click="cancel(1,scope.row)"><i class="el-icon-delete"></i> 关闭订单</el-button>
                <el-button size="mini" type="danger" v-if="scope.row.orderStatus==1" @click="handleEdit(1,scope.row)"><i class="el-icon-truck"></i> 发货</el-button>
                <el-button size="mini" type="warning" v-if="scope.row.orderStatus==1" @click="cancel(2,scope.row)"><i class="el-icon-delete"></i> 取消</el-button>
                <el-button size="mini" type="danger" v-if="scope.row.orderStatus==8" @click="handleEdit(2,scope.row)"><i class="el-icon-delete"></i> 退款</el-button>
                <!-- <el-button type="primary" @click="stopDel(scope.row)">删 除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
      </el-tabs>
      <div class="paging">
          <span>
            共
            <i class="pagingNum">{{total}}</i> 条
          </span>
          <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog :title="details.names" :visible.sync="dialogFormVisible" @close="dataClose" width="60%" class="det_cont">
        <el-form>
            <el-form-item label="订单当前状态：" class="first_line">
              <!-- <p>{{stat(details.orderStatus)}}</p> -->
                    <p class="boldfont" style="color: #efa02a;" v-if="details.orderStatus==0">待支付</p>
                    <p class="boldfont" style="color: #ff0000;" v-if="details.orderStatus==1">待发货</p>
                    <p class="boldfont" style="color: #11A983;" v-if="details.orderStatus==2">已发货</p>
                    <p class="boldfont" style="color: #efa02a;" v-if="details.orderStatus==3">已收货</p>
                    <p class="boldfont" style="color: #11A983;" v-if="details.orderStatus==4">已完成</p>
                    <p class="boldfont" style="color: #11A983;" v-if="details.orderStatus==5">已退款</p>
                    <p class="boldfont" style="color: #000000;" v-if="details.orderStatus==6">已关闭</p>
                    <p class="boldfont" style="color: #000000;" v-if="details.orderStatus==7">已无效</p>
                    <p class="boldfont" style="color: #ff0000;" v-if="details.orderStatus==8">退款中</p>
            </el-form-item>
            <!-- 订单信息 -->
            <el-form-item label="订单信息：" class="pad70">
            </el-form-item>
            <el-form-item label="订单编号：" class="det_hang">
              <p><span>{{details.orderSn}}</span><span>下单人：{{details.userName}}</span></p>
            </el-form-item>
            <el-form-item label="下单时间：" class="det_hang">
              <p><span>{{details.addTime}}</span><span>收货人：{{details.consignee}}</span></p>
            </el-form-item>
            <el-form-item label="订单状态：" class="det_hang">
              <p><span>{{stat(details.orderStatus)}}</span><span>联系电话：{{details.mobile}}</span></p>
            </el-form-item>
            <el-form-item label="收货地址：" class="det_hang">
              <p><span>{{details.province}}{{details.city}}{{details.district}}{{details.address}}</span></p>
            </el-form-item>
            <el-form-item label="取消时间：" class="det_hang">
              <p><span>{{details.closeTime}}</span><span>买家留言：{{details.message}}</span></p>
            </el-form-item>
            <!-- <el-form-item label="评价时间：" class="det_hang">
              <p><span></span><span></span></p>
            </el-form-item> -->
            <!-- 商品列表 -->
            <div>
              <el-form-item label="商品信息：" class="pad70">
              </el-form-item>
              <el-table :data="details.wxOrderGoodsInfoList" id="exportTab" border stripe style="width: 88%;margin: 2% auto;">
                <el-table-column type="index" label="序号" width="60" :index="1"></el-table-column>
                <el-table-column prop="goodsSn" label="商品编号" width="160"></el-table-column>
                <el-table-column prop="goodsName" label="商品名称" min-width="260"></el-table-column>
                <el-table-column label="商品图片" width="160">
                  <template slot-scope="scope">
                      <viewer>
                          <img class="sfzimg" :src="imgUrl+scope.row.picUrl" />
                      </viewer>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="商品售价（元）" width="160"></el-table-column>
                <el-table-column prop="number" label="购买数量" width="160"></el-table-column>
              </el-table>
            </div>
            <!-- 支付信息 -->
            <div v-if='details.orderStatus>0&&details.orderStatus!=6'>
              <el-form-item label="支付信息：" class="pad70">
              </el-form-item>
              <el-form-item label="应付款：" class="det_hang">
                <p><span>{{details.actualPrice}}元</span><span>支付方式：{{details.payType==1?'微信':'余额'}}</span></p>
              </el-form-item>
              <el-form-item label="运费：" class="det_hang">
                <p><span>{{details.freightPrice}}元</span><span>支付时间：{{details.payTime}}</span></p>
              </el-form-item>
              <el-form-item label="优惠券：" class="det_hang">
                <p><span>{{details.couponPrice}}元</span><span>实付款：{{details.actualPrice}}元</span></p>
              </el-form-item>
            </div>
            <!-- 物流信息 -->
            <div v-if='details.orderStatus>1&&details.orderStatus!=6&&details.orderStatus!=7'>
              <el-form-item label="物流信息：" class="pad70">
              </el-form-item>
              <el-form-item label="发货人：" class="det_hang">
                <p><span>{{details.shipAdminName}}</span><span></span></p>
              </el-form-item>
              <el-form-item label="发货时间：" class="det_hang">
                <p><span>{{details.shipTime}}</span><span>配送车辆：{{details.truckNumber}}</span></p>
              </el-form-item>
              <el-form-item label="收货时间：" class="det_hang logistics">
                <p><span>{{details.confirmTime}}</span><span>司机姓名：{{details.licenseName}}</span></p>
                <el-button type="primary" class="log_det" @click="logistics(details)">物流跟踪</el-button>
              </el-form-item>
              <el-form-item label=" " class="det_hang">
                <p><span></span><span>司机电话：{{details.licensePhone}}</span></p>
              </el-form-item>
            </div>
            <!-- 售后信息 -->
            <div v-if='details.refundTime'>
              <el-form-item label="售后信息：" class="pad70">
              </el-form-item>
              <el-form-item label="处理时间：" class="det_hang">
                <p><span>{{details.refundTime}}</span><span>退款金额：123</span></p>
              </el-form-item>
              <el-form-item label="处理人：" class="det_hang">
                <p><span></span><span>到账方式：用户余额</span></p>
              </el-form-item>
              <el-form-item label="状态：" class="det_hang">
                <p><span>{{details.orderStatus==5?'已处理':'未处理'}}</span><span></span></p>
              </el-form-item>
            </div>
        </el-form>
        <el-dialog id="nei" width="60%" title="物流跟踪" :visible.sync="innerVisible" append-to-body>
            <baidu-map class="map" :center="markerPoint" :zoom="zoom" :scroll-wheel-zoom="true" @zoomend="syncCenterAndZoom">
              <bm-marker :position="transportData.initial" :icon="{url:imgentrepot, size: {width: 24, height: 18}}">

              </bm-marker>
              <bm-polyline :path="polylinePath" stroke-color="red" :stroke-opacity="0.5" :stroke-weight="8" @lineupdate="updatePolylinePath"></bm-polyline>
              <bm-marker :position="markerPoint" :dragging="true" :icon="{url:imgcar, size:{width: 60, height: 60}}" @click="infoWindowOpen">
                <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">
                  <p>车&nbsp;&nbsp;&nbsp;次：{{transportData.sn}}</p>
                  <p>车牌号：{{transportData.truckNumber}}</p>
                  <p>时&nbsp;&nbsp;&nbsp;速：{{transportData.speed}} km/h</p>
                  <p>司&nbsp;&nbsp;&nbsp;机：{{transportData.licenseName}}粤A8866</p>
                </bm-info-window>
              </bm-marker>
            </baidu-map>
            <p @click='haha'>ceshi</p>
        </el-dialog>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" v-if='details.orderStatus==0' @click="cancel(1,details)">关闭订单</el-button>
            <el-button type="primary" @click="deliver(1,details)" v-if='details.orderStatus==1'>发 货</el-button>
            <el-button type="primary" @click="deliver(2,details)" v-if='details.orderStatus==8'>退 款</el-button>
            <el-button type="warning" @click="cancel(2,details)" v-if='details.orderStatus==1'>取消订单</el-button>
            <el-button @click="dialogFormVisible = false">取 消</el-button>
        </div>
    </el-dialog>
    <el-dialog :title="details.names" :visible.sync="dialogFormVisible1" width="60%" class="deliver">
        <el-form v-if="details.newAbout == 1">
            <el-form-item label="收货人：">
                <p>{{details.consignee}}</p>
            </el-form-item>
            <el-form-item label="收货人电话：">
                <p>{{details.mobile}}</p>
            </el-form-item>
            <el-form-item label="收货地址：">
                <p>{{details.province}}{{details.city}}{{details.district}}{{details.address}}</p>
            </el-form-item>
            <el-form-item label="运输车次：">
                <!-- <el-option v-for="item in cidList" :key="item.id" :label="item.group" :value="item.id">
                </el-option> -->
                <el-select v-model="details.transportId" placeholder="选择运输车次">
                    <el-option
                    v-for="item in cidList"
                    :key="item.id"
                    :label="item.group"
                    :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-form v-if="details.newAbout == 2" class="refund">
            <el-form-item label="订单编号：">
                <p><span>{{details.orderSn}}</span><span>商品合计：¥ {{details.goodsPrice}}</span></p>
            </el-form-item>
            <el-form-item label="下单人：">
                <p><span>张某某</span><span>运费：{{details.freightPrice}}</span></p>
            </el-form-item>
            <el-form-item label="收货人：">
                <p><span>{{details.consignee}}</span><span>优惠券：¥ {{details.couponPrice}}</span></p>
            </el-form-item>
            <el-form-item label="联系电话：">
                <p><span>{{details.mobile}}</span><span>实付款：¥ {{details.actualPrice}}</span></p>
            </el-form-item>
            <el-form-item label="收货地址：">
                <p>四川省成都市金牛区龙湖北城天街30栋</p>
            </el-form-item>
            <el-form-item label="退款金额：">
               <el-input placeholder="自定义退款金额" type='number' max='22' v-model="details.money" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="到账方式：">
                <p>用户余额</p>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="toDeliver">{{details.newAbout==1?'确认发货':'确认退款'}}</el-button>
            <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Provinces from "@/components/Provinces";
import Reset from "@/components/Reset";
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext'
import Paging from '@/components/Paging';
export default {
  name: "indentss",
  components: {
    Xlsx,
    EditorBar,
    Provinces,
    Reset,
    Paging
  },
  data() {
    return {
      beginData:{},
      tableData: [],
      tableData2: [],
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      dialogFormVisible1:false,
      innerVisible: false,
      details: {},
      userdata: {},
      total: 0,
      btn: [],
      fullscreenLoading: true,
      imgUrl: this.$Public.imgUrl,
      formname: JSON.stringify({name:'订单列表',hint:'indents:export'}),
      cid:'',
      cidList:[],
      status:'',
      activeName: '88',
      totNum:{total0:'',total1:'',total2:'',total3:'',total4:'',total5:'',total6:'',total7:'',total8:''},
      multipleSelection:[],

      polylinePath: [
        {lng: 116.403984, lat: 39.914004},
        {lng: 116.402116, lat: 39.913938},
        {lng: 116.401856, lat: 39.913927}
      ],
      markerPoint:{lng: 116.401856, lat: 39.913927},
      show:true,
      ceshi:[
        {lat: "30.476200850079998",lng: "105.57924354896"}
      ],
      lala:0,
      imgcar: require("../../assets/img/car.png"),
      imgentrepot:require("../../assets/img/entrepot.png"),
      zoom:15,
      transportData:{}
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  watch:{
    polylinePath(newV){
      // console.log(123321)
    }
  },
  mounted() {
    // 查询可选择发货的车辆
    this.$axios.post(`/api-s/getAllTransportRecordList/${this.userdata.areasId}`,{}, {headers: { accessToken: this.userdata.token }})
    .then(res => {
        if(res.data.success){
          res.data.transportRecordInfos.forEach(x=>{
            x.group = x.sn+'-'+x.truckNumber+'（'+x.licenseName+'）'
          })
          this.cidList = res.data.transportRecordInfos
        }
    });
  },
  methods: {
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            return this.$message('该列表无法新增内容')
        }else if(i==2){
            // if(this.btn.indexOf('indents:update')==-1){
            //     return this.$message('抱歉，用户暂无该权限')
            // }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(0,this.multipleSelection[0])
        }else if(i==3){
            return this.$message('该列表无法删除内容')
        }else if(i==4){
            this.query()
        }
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    // 获取省市传入的id
    gainSS(i){
        this.beginData.areaId = i.id
    },
    syncCenterAndZoom(e){
      this.zoom = e.target.getZoom()
    },
    // 物流跟踪(历史已经跑过路程)
    logistics(row){
      this.$axios.post(`/api-s/getGpsInfoByOrderIdList/${row.id}`,{},{headers: { accessToken: this.userdata.token }})
      .then(res=>{
        if(res.data.success){
          if(res.data.gpsInfoList.length==0){
           this.$message('该订单暂无物流信息')
           return
          }
          let log = []
          let dataArr = res.data.gpsInfoList
          dataArr.forEach(x=>{
            log.push({lng:x.lon,lat:x.lat})
          })
          this.polylinePath = log
          this.markerPoint = {lng:log[log.length-1].lng, lat:log[log.length-1].lat}
          this.innerVisible = true
          res.data.transportRecordInfo.initial = {lng:log[0].lng, lat:log[0].lat}
          res.data.transportRecordInfo.speed = dataArr[dataArr.length-1].spe
          // 信息处理
          this.transportData = res.data.transportRecordInfo
        }
      })
      // 获取最新位移
      this.$axios.post(`/api-s/getLastGpsInfoByOrderIdList/${row.id}`,{},{headers: { accessToken: this.userdata.token }})
      .then(res=>{
        if(res.data.success){
          if(res.data.gpsInfoList!=0){

          }
        }
      })
    },
    // 老司机的车
    haha(){
      this.polylinePath.push(this.ceshi[this.lala])
      this.markerPoint = this.ceshi[this.lala]
      this.lala++
    },
    updatePolylinePath (e) {
      this.polylinePath = e.target.getPath()
    },
    addPolylinePoint () {
      this.polylinePath.push({lng: 116.404, lat: 39.915})
    },
    infoWindowClose(){

    },
    infoWindowOpen(){

    },
    // 取消订单
    cancel(i,row){
      this.$confirm(`此操作将${i==2?'取消':'关闭'}该订单, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = `/api-s/setOrderStatus`
          let data = this.$qs.stringify({
              adminId:this.userdata.roleId,
              id:row.id,
              type:i
          })
          this.$axios.post(url,data,{headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.dialogFormVisible = false
                  this.begin();
              }else{
                  this.$message(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    // 车次发货
    toDeliver(){
      let url = ``
      let data = ``
      if(this.details.newAbout == 1){
        if(this.details.transportId == null){
          return this.$message('请选择运输车次')
        }
        data = this.$qs.stringify({
          adminName:this.userdata.username,
          id:this.details.id,
          transportId:this.details.transportId
        })
        url = `/api-s/deliver`
      }else if(this.details.newAbout == 2){
        if(this.details.money == undefined){
          return this.$message('请输入退款金额')
        }
        if(Number(this.details.money) < 0){
          return this.$message('请输入正确退款金额')
        }
        if(Number(this.details.money)>Number(this.details.actualPrice)){
          return this.$message('输入金额不能大于实付款')
        }
        data = this.$qs.stringify({
          adminId:this.userdata.roleId,
          adminName:this.userdata.username,
          id:this.details.id,
          money:this.details.money
        })
        url = `/api-s/returnOrder`
      }
      this.$axios.post(url,data, {headers: { accessToken: this.userdata.token }})
      .then(res=>{
        if(res.data.success){
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
          this.dialogFormVisible = false
          this.dialogFormVisible1 = false
          this.begin()
        }else{
          this.$message(res.data.msg)
        }
      })
    },
    deliver(i,row){
      this.handleEdit(i,row)
    },
    stat(i){
      if(i==0){
        return `待支付`
      }else if(i==1){
        return `待发货`
      }else if(i==2){
        return `已发货`
      }else if(i==3){
        return `已收货`
      }else if(i==4){
        return `已完成`
      }else if(i==5){
        return `已退款`
      }else if(i==6){
        return `已关闭`
      }else if(i==7){
        return `已无效`
      }else if(i==8){
        return `退款中`
      }
    },
    handleClick(tab, event) {
      if(this.activeName == '88'){
        this.beginData.orderStatus = ''
      }else{
        this.beginData.orderStatus = this.activeName
      }
      this.begin()
    },
    // 关闭清空内容
    dataClose(){
      this.details = {}
    },
    change(val) {
      console.log(val)
    },
    reset() {
      this.fullscreenLoading = true;
      this.beginData = {orderStatus:this.beginData.orderStatus}
      this.begin()
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin();
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        consignee:this.beginData.consignee,
        goodsName:this.beginData.goodsName,
        mobile:this.beginData.mobile,
        orderSn:this.beginData.orderSn,
        orderStatus:this.beginData.orderStatus,
        userName:this.beginData.userName,
        adminAreasId: userdata.areasId,
        areaId:this.beginData.areaId
      });
      this.$axios
        .post(`/api-s/getOrderList`, data, {
          headers: { accessToken: userdata.token }
        })
        .then(res => {
          this.fullscreenLoading = false;
          if(res.data.success){
            // this.$set(this, "tableData", res.data.pageInfo.list);

            this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
              this.$set(this, "tableData", res.data.pageInfo.list);
              this.totNum = res.data
            });
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
                type: 'success',
                message: res.data.msg
            });
          }else{
            this.$message(res.data.msg)
          }
        });
    },
    handleEdit(i,row) {
      if(i==0){
        row.newStat = i
        row.names = '订单详情'
        this.dialogFormVisible = true;
      }else if(i==1){
        row.newAbout = i
        row.names = '订单发货'
        this.dialogFormVisible1 = true;
      }else if(i==2){
        row.newAbout = i
        row.names = '退款处理'
        this.dialogFormVisible1 = true;
      }
      this.details = row
    },
    stopDel(row) {
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          url = `/api-s/deleteOrder/${row.id}`
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.begin();
              }else{
                  this.$message(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    // //   多选编辑
    // handleSelectionChange(val) {
    //     this.multipleSelection = val;
    // },
    // //   多选删除
    // choice(){
    //     if(this.multipleSelection.length == 0){
    //         return this.$message('请至少选择一项删除')
    //     }
    //     let arr = []
    //     this.multipleSelection.forEach(x=>{
    //         arr.push(x.id)
    //     })
    //     this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //     }).then(() => {
    //         let url = ``
    //         url = `/api-s/deleteOrder/${arr.join(',')}`
    //         this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
    //         .then(res=>{
    //             if(res.data.success==true){
    //                 this.$message({
    //                     type: 'success',
    //                     message: res.data.msg
    //                 });
    //                 this.begin();
    //             }else{
    //                 alert(res.data.msg)
    //             }
    //         })
    //     }).catch(() => {
    //         return
    //     });
    // },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
#indents .el-input__inner {
  margin: 10px 0;
}
#indents .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#indents .el-menu-item.is-active{
  background: none
}
#indents .mark{
  position: absolute;
  top: -6px;
  right: 4px;
}
.lastmark{
  right: -16px !important;
}
#indents .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#indents .el-tag{
  margin-right: 12px;
}
#indents .el-select {
  width: 100%
}
#indents .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#indents .el-upload-list--picture .el-upload-list__item {
    width: 44%;
    float: left;
    margin-right: 2%;
}
#indents .el-form-item__content {
    width: 100%;
}
#indents .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#indents .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#indents .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#indents .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#indents .el-dialog__body {
  height: 382px;
}
#indents .refund p{
  display: flex;
}
#indents .refund p span{
  width: 48%
}
#indents .deliver .el-dialog__body {
  height: 100%;
}
#indents .deliver .el-form-item{
    align-items: center;
}
.map{
  width: 100%;
  height:100%;
}
#indents .deliver .el-dialog {
  margin-top: 24vh !important;
}
/* #indents .deliver .el-dialog {
  height: 100%;
} */
#indents #nei .el-dialog{
  margin-top: 15vh !important;
  height: 80vh !important;
}
#indents #nei .el-dialog__body{
  height: 100% !important;
}
#indents .el-form-item{
    display: flex;
    /* align-items: center; */
    margin-bottom:0
}
#indents .el-form-item__label{
    width:192px
}
#indents .deliver .el-form-item__label{
    width: 160px;
}
/* #indents .el-form-item__label:first-child{
  font-size: 16px;
} */
.viewer-transition {
  z-index: 9999 !important;
}
.pad70 .el-form-item__label{
  padding-right: 52px;
  font-size: 16px;
  font-weight: 600;
}
.det_hang p{
    display: flex;
    justify-content: space-between;
    width: 84%;
}
.det_hang p>span{
    width: 49%;
}
.first_line .el-form-item__label{
  font-size: 16px;
  font-weight: 600;
}
/* 物流跟踪 */
.logistics{
  position: relative;
}
.log_det{
  position: absolute;
  right: 16px;
  top: -30px;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
    color: red;
    margin-left: 8px;
}
.det_cont .first_line p{
  font-size: 16px;
  font-weight: 600;
}
</style>
